// Autogenerated file
export const messageMediaTypesEnum = {
    Text: "Text",
    File: "File",
    Voice: "Voice",
};
export const messageMediaTypes = [
    { label: "Текст", value: "Text" },
    { label: "Файл", value: "File" },
    { label: "Голосовое сообщение", value: "Voice" },
];
